export default __webpack_public_path__ + "static/bank_axept.png";